export default __webpack_public_path__ + "static/media/02.576cfeb0.jpg";